// extracted by mini-css-extract-plugin
export default {"stacked":"wEn8Wy"};